export default {
  header: {
    dark: "Tema oscuro",
    light: "Tema claro",
    system: "Tema del navegador",
    environment: "Trabaja en el entorno de pruebas",
    notification: {
      empty: "Ningún procesamiento en curso...",
      waiting: "En espera de información sobre el procesamiento",
      list: "Ver todo el historial",
      historic: "Historial de procesamientos",
      download: "Descargar",
      file: "Su archivo",
    },
  },
  menu: "Menú",
  dashboard: {
    timeline: "Línea temporal",
    timeline_actions: {
      delete: {
        confirmation: "¿Está seguro de que desea eliminar esta fila?",
        success: "¡Fila eliminada con éxito!",
      },
    },
    indicator: "Indicadores",
    indicators: {
      see_details: "Ver detalle de las tasas de respuesta",
      see_details_complete_triad: "Tasa de trinomios completos",
      fill_rate: "Tasa de respuesta",
    },
    shared_docs: "Documentos compartidos",
    registration: "Inscripciones",
    welcome_to_studea: "¡Bienvenidos a su portal Studea!",
    welcome_to_dashboard: "Bienvenido a su panel de control",
    your_actually_are: "Ahora mismo está",
    welcome_message: ({ named }) => `¡Bienvenido/a, <strong>${named("name")}</strong> a su portal Studea!`,
    no_training_course_archived: "Ninguna promoción archivada",
    no_training_course_actived: "Ninguna promoción activa",
    no_triad: "Ningún trinomio",
    triad_search_placeholder: "Buscar",
    triad_members: "Miembros del trinomio",
    questionnaires_empty: "No hay cuestionario para completar",
    contract: {
      company_sheet: "Ficha de empresa",
      type: "Tipo de contrato :",
      company: "Empresa:",
      dates: "Fechas del contrato:",
      rupture_date: "Fecha de rescisión del contrato",
      rupture_cause: "Motivo de la ruptura",
      siret: "Siret:",
      address: "Dirección :",
      from: "Del",
      to: "al",
      by: "por",
      secondary: "secundario",
      vised_cerfa: "CERFA certificado",
      mission_file: "Declaración de objetivos",
      rupture_justificative: "Expediente de justificación",
      rupture_invalidtion_confirmation:
        "¿Estás seguro de que quieres anular la validación de este incumplimiento de contrato?",
      rupture_declared: "Incumplimiento declarado el",
      rupture_validated: "Validar el incumplimiento",
      rupture_invalidate: "Invalidar el incumplimiento",
      invalidate: "Invalidar",
      date_overlaps:
        "Algunas fechas de los contratos se superponen. Por favor, registre la finalización del contrato anterior o verifique las fechas introducidas en los contratos.",
    },
    archived_training_course: ({ plural, named }) =>
      plural([`Ver las ${named("label")}s archivadas`, `Ver los ${named("label")}s archivados`]),
    unarchived_training_course: ({ plural, named }) =>
      plural([`Ver las ${named("label")}s activas`, `Ver los ${named("label")}s activos`]),
    Download_the_booklet: "Descargar el cuaderno",
    Download_the_booklet_with_documents: "Descargar el cuaderno con estos documentos",
    Download_key_dates: "Descargar las fechas clave",
    session_lock: "Esta sesión todavía no está abierta para las selecciones.",
    skill_lock:
      "No puede modificar \nesta competencia, que se \ncalcula según sus respuestas a los \ncuestionarios o que no \ntiene asignada",
    driverLicence: {
      config: "Gestion des aides permis B",
      confirmation_send: "Le pilote rattaché à votre dossier a été notifié de votre demande.",
      progress: {
        paymentDate: "Date de paiement",
        requestDate: "Date de la demande",
        transmissionDate: "Date de transmission au service financier",
        validationDate: "Date de validation",
      },
    },
    skill: {
      rate_by_profil: "Índice de cobertura de competencias por perfil",
    },
  },
  driver_licence: {
    info: "Su expediente se enviará cuando se hayan presentado todos los documentos adjuntos.",
    triad_list: "Ver la lista de trinomios",
  },
};
